<fieldset class="container-handling col-12">
  <legend class="h6 text-dark mb-3">{{ mode() | titlecase }} containers</legend>

  <div class="container-handling-grid">
    <div class="row g-3 mb-3">
      <div class="col-3 fw-regular">Container type</div>
      <div class="col-2 text-end fw-regular">Full</div>
      <div class="col-2 text-end fw-regular">Empty</div>
      <div class="col-1 text-end"></div>
    </div>

    @for (group of containerHandlingGroups()?.controls; track group) {
      <div class="row g-3 align-items-center mb-3">
        <div class="col-3 container-type">{{ formatContainerType(group) }}</div>
        <div class="col-2">
          <input
            class="form-control text-end w-100 no-spin validatable"
            type="number"
            step="1"
            maxlength="9"
            [formControl]="group.controls.full"
            [placeholder]="'0'"
            [class.ng-invalid]="showFieldError(group.controls.full)">
        </div>
        <div class="col-2">
          <input
            class="form-control text-end w-100 no-spin validatable"
            type="number"
            step="1"
            maxlength="9"
            [formControl]="group.controls.empty"
            [placeholder]="'0'"
            [class.ng-invalid]="showFieldError(group.controls.empty)">
        </div>
        <div class="col-2 text-end container-total row-total">{{ rowTotal(group) }}</div>
      </div>
    }

    <div class="row g-3">
      <div class="col-3"></div>
      <div class="col-2 text-end container-total">{{ columnTotals().full }}</div>
      <div class="col-2 text-end container-total">{{ columnTotals().empty }}</div>
      <div class="col-2 text-end container-total">{{ columnTotals().total }}</div>
    </div>

    @if (hasNoContainerCountsError() && showValidationErrors()) {
      <div class="row g-3">
        <div class="col-12 invalid invalid-feedback ng-invalid">Enter at least one container count</div>
      </div>
    }
  </div>
</fieldset>
